import { render, staticRenderFns } from "./send-list-wrapper.vue?vue&type=template&id=056c8741"
import script from "./send-list-wrapper.vue?vue&type=script&lang=js"
export * from "./send-list-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056c8741')) {
      api.createRecord('056c8741', component.options)
    } else {
      api.reload('056c8741', component.options)
    }
    module.hot.accept("./send-list-wrapper.vue?vue&type=template&id=056c8741", function () {
      api.rerender('056c8741', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/send-list-wrapper.vue"
export default component.exports